import type {
  Channel,
  EngageChannel,
  MergedChannel,
} from '~/modules/account/types'

export default function mergeChannels(
  channels: Channel[],
  engageChannels: EngageChannel[],
): MergedChannel[] {
  if (!channels || !engageChannels) {
    return []
  }

  const result: MergedChannel[] = []

  engageChannels.forEach((engageChannel) => {
    const { id, ...engageChannelData } = engageChannel
    const channel = channels.find((el) => el.serviceId === id)

    if (channel) {
      result.push({
        ...channel,
        ...engageChannelData,
        __typename: 'MergedChannel',
      })
    }
  })

  // Add Instagram login channels that need to be reauthorized
  channels.forEach((channel) => {
    const isInstagramLogin =
      channel.service === 'instagram' && channel.apiVersion === 'instagramLogin'
    const notInResult = !result.some((r) => r.serviceId === channel.serviceId)

    if (isInstagramLogin && notInResult) {
      result.push({
        ...channel,
        needsReauth: true,
        backfillingComplete: true,
        __typename: 'MergedChannel',
      })
    }
  })

  return result
}
